import script from "./PixKeyWizardActionButtonContainer.vue?vue&type=script&lang=jsx&setup=true"
export * from "./PixKeyWizardActionButtonContainer.vue?vue&type=script&lang=jsx&setup=true"

const __exports__ = script;

export default __exports__